module.exports = __webpack_public_path__ + "img/sq2.3a1a7678.png";